import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import { RowBetween } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import { useTodayRewards } from 'state/bonus/hooks/dailyReward'
import styled from 'styled-components'
import colors from 'theme/ui/colors'
import useDailyCheckinModal from 'views/DailyCheckin'

const DailyCheckinMenu = () => {
  const [onPresentDailyCheckinModal] = useDailyCheckinModal()
  const { currentRewards } = useTodayRewards()

  const isWaitingClaimReward = currentRewards?.some((item) => item.isWaitingClaim)

  return (
    <StyledExtendMenuItem
      id="menu-bonusCenter"
      onClick={() => onPresentDailyCheckinModal()}
      mt="4px"
      borderRadius="8px"
      overflow="hidden"
      position="relative"
    >
      <RowBetween width="100%" top="0px" position="absolute" px="8px">
        <Flex justifyContent="center" alignItems="center" height="44px">
          <Box position="relative" width="24px">
            <Image src="/images/daily-checkin.png" width={400} height={400} alt="daily-checkin" />
          </Box>
          <Flex flexDirection="column" ml="8px">
            <StyledTitle fontSize="14px !important" color="textTertiary" fontWeight={500}>
              <Trans>Daily Checkin</Trans>
            </StyledTitle>
          </Flex>
        </Flex>
        {isWaitingClaimReward && (
          <Box width="8px" height="8px" background={colors.strokeAlt3} borderRadius="50%" ml="4px" />
        )}
      </RowBetween>
    </StyledExtendMenuItem>
  )
}

const StyledExtendMenuItem = styled(Flex)`
  height: 44px;
  cursor: pointer;
  align-items: center;
  padding-right: 2px;
  border-radius: ${({ theme }) => theme.radii.tiny} !important;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;

  ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
    max-width: 204px;
  }

  &:after {
    content: '';
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    transition: ease ${({ theme }) => theme.transitions.fast};
    background: linear-gradient(270deg, rgba(255, 255, 255, 0.4) -2.78%, rgba(255, 255, 255, 0) 87.04%);
  }

  &:hover {
    &:after {
      opacity: 1;
    }
  }
`
const StyledTitle = styled(Text)`
  font-size: 12px;
  line-height: 1.2em;
`

export default DailyCheckinMenu
